export enum EHeroObjective {
  REACH = 'REACH',
  SALES = 'SALES',
  CONVERSIONS = 'CONVERSIONS',
}
